<!-- <app-jobs-candidates-slide-filter  [valuesSentForFilters]="entitySent"
  (valuesRetainedForFilters)="onFilterToggle($event)">
  <ng-container *ngIf="panel == 'job-applicants'" [ngTemplateOutlet]="jobApplicantFilterTemplate"></ng-container>
</app-jobs-candidates-slide-filter>

<ng-template #jobApplicantFilterTemplate>
  <app-job-applicant-filter></app-job-applicant-filter>
</ng-template> -->
<!-- [class.stickthere-job-applicants]="widgetstick" --> 
<ng-container *ngIf="designVersion === 'v3'">
  <!-- Stat Cards -->
  <div class="jc-v3-stat-grid jc-v3-stat-grid-4">
    <div class="jc-v3-stat-card acc-purple"><div class="jc-v3-s-label">Total Applicants</div><div class="jc-v3-s-value">{{ stageCounts?.all || 0 }}</div><div class="jc-v3-s-sub">All time</div></div>
    <div class="jc-v3-stat-card acc-green"><div class="jc-v3-s-label">In Process</div><div class="jc-v3-s-value">{{ stageCounts?.inProcess || 0 }}</div><div class="jc-v3-s-sub">Active pipeline</div></div>
    <div class="jc-v3-stat-card acc-amber"><div class="jc-v3-s-label">Selected</div><div class="jc-v3-s-value">{{ stageCounts?.selected || 0 }}</div><div class="jc-v3-s-sub">Shortlisted</div></div>
    <div class="jc-v3-stat-card acc-blue"><div class="jc-v3-s-label">Onboarded</div><div class="jc-v3-s-value">{{ stageCounts?.onboarded || 0 }}</div><div class="jc-v3-s-sub">Completed</div></div>
  </div>

  <!-- Pipeline Filter Tabs + Search -->
  <div class="jc-v3-pip-bar">
    <button class="jc-v3-pip-tab" [class.active]="!selectedStage || selectedStage === 'ALL'" (click)="selectStage('ALL')">
      All <span class="jc-v3-pip-cnt">{{ stageCounts?.all || 0 }}</span>
    </button>
    <button class="jc-v3-pip-tab" [class.active]="selectedStage === 'JOB-APPLIED'" (click)="selectStage('JOB-APPLIED')">
      Applied <span class="jc-v3-pip-cnt">{{ stageCounts?.applied || 0 }}</span>
    </button>
    <button class="jc-v3-pip-tab" [class.active]="selectedStage === 'CANDIDATE-SHORTLISTED,INTERVIEW-SCHEDULED,INTERVIEW-ACCEPTED,L1-INTERVIEW,L2-INTERVIEW,L3-INTERVIEW'" (click)="selectStage('CANDIDATE-SHORTLISTED,INTERVIEW-SCHEDULED,INTERVIEW-ACCEPTED,L1-INTERVIEW,L2-INTERVIEW,L3-INTERVIEW')">
      In Process <span class="jc-v3-pip-cnt">{{ stageCounts?.inProcess || 0 }}</span>
    </button>
    <button class="jc-v3-pip-tab" [class.active]="selectedStage === 'CANDIDATE-SELECTED'" (click)="selectStage('CANDIDATE-SELECTED')">
      Selected <span class="jc-v3-pip-cnt">{{ stageCounts?.selected || 0 }}</span>
    </button>
    <button class="jc-v3-pip-tab" [class.active]="selectedStage === 'OFFERED,OFFER-ACCEPTED'" (click)="selectStage('OFFERED,OFFER-ACCEPTED')">
      Offers <span class="jc-v3-pip-cnt">{{ stageCounts?.offered || 0 }}</span>
    </button>
    <button class="jc-v3-pip-tab" [class.active]="selectedStage === 'PRE-ONBOARDED,ONBOARDED'" (click)="selectStage('PRE-ONBOARDED,ONBOARDED')">
      Onboards <span class="jc-v3-pip-cnt">{{ stageCounts?.onboarded || 0 }}</span>
    </button>
    <div class="jc-v3-cand-srch">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
      <input type="text" placeholder="Search Candidates, Title, ID" [(ngModel)]="searchText" (input)="filterCandidates()">
    </div>
    <div class="jc-v3-icon-btn" (click)="openFilterSlider()">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>
      <span *ngIf="jobApplicantStatusList?.length > 0" class="filter-count">{{jobApplicantStatusList.length}}</span>
    </div>
  </div>

  <!-- Candidate list — scroll is owned by the outer `.jc-v3-entity-details-body`
       (see job-center-v3.scss:2323). Previously this div had its own
       `height: calc(100vh - 380px); overflow-y: auto` which stacked a
       second scrollbar inside the already-scrollable body. Infinite scroll
       now listens on the outer container via `[infiniteScrollContainer]`
       + `[fromRoot]="true"` so pagination still fires at the right time. -->
  <!-- Job-level disable: blocked / non-active job greys the candidate list
       and blocks pointer events — moved onto app-candidate-card-table-view
       below (not this wrapper) so it no longer also dims the "No Applicants
       Yet" empty state below it, which has nothing to grey out or block
       clicks on. -->
  <div infiniteScroll
       [infiniteScrollDistance]="5"
       [infiniteScrollThrottle]="200"
       [infiniteScrollContainer]="'.jc-v3-entity-details-body'"
       [fromRoot]="true"
       [alwaysCallback]="true"
       (scrolled)="onScrollDown()">
    <!-- Status-update parity with V2 row-design (candidate-card.html:283-285).
         card-table-view now owns the full pipeline locally:
         validateNegativeStatus → B2B validation → RTR modal →
         POST /candidates/updatejobAppliedStatus → freeze/invalidate side-
         effects → searchData broadcast. After API success it emits:
           (jobapp_to_newjob_to_atvity) → `pushtoparentcomponent` re-maps
             response[] (isSelected + activityDate) so the row repaints
             without a full reload.
           (statusUpdated) → `statusUpdateTriggered` calls
             `getApplicantsCounts(jobDetails)` to refresh stage counters.
         (onStatusUpdate) is kept as a no-op safety net for callers that
         still emit the old wrapped event. -->
    <app-candidate-card-table-view *ngIf="response?.length > 0"
      [ngClass]="{'disabled': !jobDetails?.availability || jobDetails?.status !== 'ACTIVE'}"
      [pageName]="pagelist"
      [response]="response"
      [jobDetails]="jobDetails"
      [userId]="userId"
      [filterApplicantData]="filterApplicantData"
      [designVersion]="'v3'"
      [From]="'APPLICANT'"
      (statusUpdated)="statusUpdateTriggered($event)"
      (jobapp_to_newjob_to_atvity)="pushtoparentcomponent($event)"
      (onOpenDocuments)="openDocuments($event)"
      (inviteClicked)="invite($event)">
    </app-candidate-card-table-view>

    <!-- Loading Skeleton -->
    <div class="col-12" *ngIf="loadAPIcall && response?.length === 0">
      <app-common-skeleton [countforView]="4" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
    </div>
    <div class="col-12" *ngIf="loadAPIcall && response?.length > 0">
      <app-common-skeleton [countforView]="2" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
    </div>

    <!-- No Results — v3 styled empty state -->
    <div *ngIf="!loadAPIcall && response?.length === 0" class="jc-v3-empty-state">
      <svg width="200" height="180" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="100" cy="90" r="80" fill="#F5F3FF"/>
        <rect x="54" y="44" width="76" height="96" rx="7" fill="#ffffff" stroke="#7C3AED" stroke-width="1.8"/>
        <path d="M118 44 L130 56 L118 56 Z" fill="#C4B5FD"/>
        <rect x="64" y="64" width="52" height="4" rx="2" fill="#DDD6FE"/>
        <rect x="64" y="74" width="44" height="4" rx="2" fill="#EDE9FE"/>
        <rect x="64" y="84" width="48" height="4" rx="2" fill="#EDE9FE"/>
        <rect x="64" y="94" width="38" height="4" rx="2" fill="#EDE9FE"/>
        <circle cx="132" cy="122" r="20" fill="#7C3AED" opacity="0.10"/>
        <circle cx="132" cy="122" r="15" fill="#ffffff" stroke="#7C3AED" stroke-width="2.2"/>
        <line x1="143" y1="133" x2="152" y2="142" stroke="#7C3AED" stroke-width="3" stroke-linecap="round"/>
        <circle cx="48" cy="48" r="3.5" fill="#A78BFA"/>
        <circle cx="158" cy="58" r="2.5" fill="#C4B5FD"/>
      </svg>
      <h3>{{ applicantsFoundStatus || 'No Applicants Yet' }}</h3>
      <p>Applicants for this job will appear here once candidates apply.</p>
    </div>

    <!-- Bottom Reached -->
    <div *ngIf="stopscrollFlag && response?.length > 0" class="jc-v3-list-done">
      <ng-icon name="tablerCircleCheck"></ng-icon>
      <p>You've reached the bottom of the page</p>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="designVersion !== 'v3'">
<!-- Job-level disable: blocked / non-active job greys the whole
     Applicants V2 listing and blocks pointer events. -->
<div id="entity-container"
  [ngClass]="{'disabled': !jobDetails?.availability || jobDetails?.status !== 'ACTIVE'}">

  <!-- Header Row with Stage Counts and Search/Filter -->
  <div class="header-row">
    <!-- Stage Count Section (Left Half) -->
    <div class="stage-count-section">
      <!-- All Tab (Default) -->
      <div
        class="stage-count-item all"
        [class.active]="!selectedStage || selectedStage === 'ALL'"
        (click)="selectStage('ALL')">
         <div class="stage-label">All</div>
         <div >{{stageCounts?.all || 0}}</div>
      </div>

      <div
        class="stage-count-item applied"
        [class.active]="selectedStage === 'JOB-APPLIED'"
        (click)="selectStage('JOB-APPLIED')">
        <div class="stage-label">Applied</div>
        <div >{{stageCounts?.applied || 0}}</div>
      
      </div>

      <div
        class="stage-count-item in-process"
        [class.active]="selectedStage === 'CANDIDATE-SHORTLISTED,INTERVIEW-SCHEDULED,INTERVIEW-ACCEPTED,L1-INTERVIEW,L2-INTERVIEW,L3-INTERVIEW'"
        (click)="selectStage('CANDIDATE-SHORTLISTED,INTERVIEW-SCHEDULED,INTERVIEW-ACCEPTED,L1-INTERVIEW,L2-INTERVIEW,L3-INTERVIEW')">
         <div class="stage-label">In Process</div>
        <div >{{stageCounts?.inProcess || 0}}</div>

      </div>

      <div
        class="stage-count-item selections"
        [class.active]="selectedStage === 'CANDIDATE-SELECTED'"
        (click)="selectStage('CANDIDATE-SELECTED')">
         <div class="stage-label">Selected</div>
        <div >{{stageCounts?.selected || 0}}</div>
       
      </div>

      <div
        class="stage-count-item offers"
        [class.active]="selectedStage === 'OFFERED,OFFER-ACCEPTED'"
        (click)="selectStage('OFFERED,OFFER-ACCEPTED')">
          <div class="stage-label">Offers</div>
        <div >{{stageCounts?.offered || 0}}</div>
      
      </div>

      <div
        class="stage-count-item onboards"
        [class.active]="selectedStage === 'PRE-ONBOARDED,ONBOARDED'"
        (click)="selectStage('PRE-ONBOARDED,ONBOARDED')">
          <div class="stage-label">Onboards</div>
        <div >{{stageCounts?.onboarded || 0}}</div>
      
      </div>
    </div>


    <!-- Search and Filter Section (Right Side - Expandable) -->
    <div class="search-filter-section">
      <!-- <div class="search-wrapper" [class.expanded]="searchExpanded">
        <div class="search-input-container">
          <div class="search-icon-wrapper">
            <ng-icon name="tablerSearch"></ng-icon>
          </div>
          <input
            #searchInput
            id="job_applicants_search"
            type="text"
            class="search-input-field"
            placeholder="Search candidates..."
            [(ngModel)]="searchText"
            (keyup)="filterCandidates()"
            (blur)="onSearchBlur()"
            (focus)="onSearchFocus()">
        </div>
        <button class="icon-btn search-toggle-btn" title="Search" (click)="toggleSearch()">
          <ng-icon name="tablerSearch"></ng-icon>
        </button>
      </div> -->

      <div class="search-container-650-1">
        <ng-icon name="tablerSearch" class="search-icon-650-1"></ng-icon>
        <input type="text" #searchInput 
          id="job_applicants_search" 
          class="search-box-650" 
          placeholder="Search Candidates,Title,ID,Tags" 
          [(ngModel)]="searchText"
          (keyup)="filterCandidates()">
      </div>

      <button id="job_applicants_filter_button" class="icon-btn filter-btn" (click)="openFilterSlider()" title="Filter">
        <ng-icon name="tablerFilter"></ng-icon>
        <span *ngIf="jobApplicantStatusList?.length > 0" class="filter-count">{{jobApplicantStatusList.length}}</span>
      </button>
    </div>
  </div>

  <!-- Use the new candidate card table view component -->
  <!-- <app-candidate-card-table-view
    [pageName]="'job-applicants'"
    [response]="response"
    [loadAPIcall]="loadAPIcall"
    [stopscrollFlag]="stopscrollFlag"
    [responseReceived]="responseReceived"
    [jobDetails]="jobDetails"
    [userId]="userId"
    [showTimeline]="true"
    [filterApplicantData]="filterApplicantData"
    (onCandidateClick)="route($event)"
    (onViewProfile)="open($event)"
    (onDownloadResume)="downloadResume($event)"
    (onSendMessage)="openMessagecheckInteraction($event)"
    (onOpenDocuments)="openDocuments($event)"
    (onShareProfile)="shareProfile($event)"
    (onScheduleInterview)="scheduleInterview($event)"
    (onAddNotes)="addNotes($event)"
    (onStatusUpdate)="updateStatus($event.status, $event.candidate)"
    (showDetails)="showDetails($event,DetailsPopup)"
    >
  </app-candidate-card-table-view> -->

  <!-- Table Structure using candidate-card with row-design view -->
  <div class="applicants-table-wrapper" #scrollContainer
    [style.height]="'calc(100vh - 274px)'"
    infiniteScroll [infiniteScrollDistance]="5" [scrollWindow]="false"
    [infiniteScrollThrottle]="200" [alwaysCallback]="true" (scrolled)="onScrollDown()">
    <div class="applicants-table-container hpanel">

      <!-- Table Header -->
      <div class="applicants-table-header panel-body">
        <div class="header-cell rank-col">Rank</div>
        <div class="header-cell candidate-col">Candidate</div>
        <div class="header-cell location-col">Title & Location</div>
        <div class="header-cell skills-col">Skills</div>
        <div class="header-cell match-col">Match %</div>
        <div class="header-cell engagement-col">Engagement</div>
        <div class="header-cell stage-col">Stage</div>
        <div class="header-cell actions-col">Quick Actions</div>
      </div>

      <!-- Loading Skeleton - Initial Load -->
      <div class="col-12" *ngIf="loadAPIcall && response?.length==0">
        <app-common-skeleton [countforView]="4" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
      </div>

      <!-- Candidate Rows using candidate-card with row-design view -->
      <ng-container *ngIf="response.length > 0; else noResult">
        <div class="applicants-table-body">
          <ng-container *ngFor="let item of response; let i = index">
            <app-candidate-card
              [candidateval]="setRankAndShowSkills(item, i + 1)"
              [viewSize]="'row-design'"
              [pageName]="pagelist"
              [jobDetails]="jobDetails"
              [userId]="userId"
              [showStatus]="true"
              [filterApplicantData]="filterApplicantData"
              [appliedJobDetails]="appliedJob"
              [showTimeline]="true"
              [currentJobId]="jobDetails?.jobId"
              (statusUpdated)="statusUpdateTriggered($event)"
              (jobapp_to_newjob_to_atvity)="pushtoparentcomponent($event)"
              (candidateEmitter)="passCandidateId($event)">
            </app-candidate-card>
          </ng-container>
        </div>

        <!-- Loading Skeleton - During Scroll/Pagination -->
        <div class="col-12" *ngIf="loadAPIcall && response.length > 0">
          <app-common-skeleton [countforView]="2" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
        </div>

        <!-- Bottom Reached Message -->
        <div *ngIf="stopscrollFlag && response.length > 0" class="caught_up">
          <div class="col-md-12">
            <ng-icon name="tablerCircleCheck"></ng-icon>
          </div>
          <div class="col-md-12">
            <p class="biase"> You've reached the bottom of the page </p>
          </div>
        </div>
      </ng-container>

      <!-- No Results Template -->
      <ng-template #noResult>
        <div class="wert">
          <div class="col-md-12 mg-bt-9">
            <ng-icon name="tablerZoomQuestion" *ngIf="responseReceived"></ng-icon>
            <ng-icon name="tablerUserSearch" *ngIf="!responseReceived"></ng-icon>
          </div>
          <div class="col-md-12 fig">{{applicantsFoundStatus}}</div>
        </div>
      </ng-template>

    </div><!-- End of applicants-table-container -->
  </div><!-- End of applicants-table-wrapper -->
</div>
</ng-container>

<!-- Document Management Component -->
<app-candidate-documents
  *ngIf="selectedCandidateForDocument"
  [pageName]="'candidate-card'"
  [isOpen]="showDocumentSection"
  [listOfDocuments]="typeOfDocuments"
  [candidateId]="selectedCandidateForDocument.candidateId"
  [jobId]="jobDetails.jobId"
  [count]="totalMandatoryDocuments"
  [allDocumentsVerified]="allVerified"
  (close)="closeDocuments()"
  (save)="saveDocuments($event)"
  (dataChanged)="refreshDocumentData()">
</app-candidate-documents>

  <ng-template #DetailsPopup let-modal>
    <div class="match-details-modal">
      <!-- Enhanced Header with Score Badge -->
      <div class="modal-header-enhanced">
        <div class="header-content">
          <div class="score-badge-container">
            <div class="score-badge">
              <span class="score-value">{{candidateScore}}</span>
              <span class="score-label">Match Score</span>
            </div>
          </div>
          <div class="header-text">
            <h3 class="modal-title">Candidate Match Analysis</h3>
            <p class="modal-subtitle">Detailed breakdown of compatibility factors</p>
          </div>
        </div>
        <button type="button" class="close-btn-modern" aria-label="Close" (click)="closeModal()">
          <ng-icon name="tablerX"></ng-icon>
        </button>
      </div>

      <!-- Modal Body with Enhanced Sections -->
      <div class="modal-body-enhanced">
        <div *ngFor="let r of reasons; let i = index" class="reason-card">

          <!-- Overall Reason Section -->
          <div class="reason-summary-section">
            <div class="section-icon reason-icon">
              <ng-icon name="tablerInfoCircle"></ng-icon>
            </div>
            <div class="section-content">
              <h4 class="section-title">Match Summary</h4>
              <p class="reason-summary-text">{{ r.reason }}</p>
            </div>
          </div>

          <!-- Strengths Section with Green Theme -->
          <div class="strengths-section">
            <div class="section-header">
              <div class="section-icon strengths-icon">
                <!-- <ng-icon name="tablerCircleCheck"></ng-icon> -->
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd" />
                      </svg>
              </div>
              <h4 class="section-title strengths-title">
                Strengths
                <span class="count-badge strengths-badge">{{ r.strengths?.length || 0 }}</span>
              </h4>
            </div>
            <div class="section-body">
              <div class="strength-item" *ngFor="let s of r.strengths; let idx = index">
                <div class="item-bullet strengths-bullet">
                  <!-- <ng-icon name="tablerCheck"></ng-icon> -->
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd" />
                  </svg>
                </div>
                <span class="item-text">{{ s }}</span>
              </div>
              <div *ngIf="!r.strengths || r.strengths.length === 0" class="empty-state">
                <ng-icon name="tablerInfoCircle"></ng-icon>
                <span>No specific strengths identified</span>
              </div>
            </div>
          </div>

          <!-- Weaknesses Section with Red Theme -->
          <div class="weaknesses-section">
            <div class="section-header">
              <div class="section-icon weaknesses-icon">
                <!-- <ng-icon name="tablerAlertTriangle"></ng-icon> -->
                <ng-icon name="tablerAlertTriangle"></ng-icon>
              </div>
              <h4 class="section-title weaknesses-title">
                Areas for Improvement
                <span class="count-badge weaknesses-badge">{{ r.weaknesses?.length || 0 }}</span>
              </h4>
            </div>
            <div class="section-body">
              <div class="weakness-item" *ngFor="let w of r.weaknesses; let idx = index">
                <div class="item-bullet weaknesses-bullet">
                  <!-- <ng-icon name="tablerCircleMinus"></ng-icon> -->
                  <ng-icon name="tablerAlertCircle"></ng-icon>
                </div>
                <span class="item-text">{{ w }}</span>
              </div>
              <div *ngIf="!r.weaknesses || r.weaknesses.length === 0" class="empty-state">
                <ng-icon name="tablerThumbUp"></ng-icon>
                <span>No significant gaps identified</span>
              </div>
            </div>
          </div>

          
        </div>

        <!-- Empty State if No Reasons -->
        <div *ngIf="!reasons || reasons.length === 0" class="no-data-state">
          <ng-icon name="tablerSearch"></ng-icon>
          <p>No match analysis available for this candidate.</p>
        </div>
      </div>

      <!-- Enhanced Footer -->
      <div class="modal-footer-enhanced">
        <button class="btn-close-modern" (click)="closeModal()">
          Close
        </button>
      </div>
    </div>
  </ng-template>

<!-- Invite-to-apply modal — same template used by talent-pool +
     suggested-candidates-ai-list. Mounts a stripped `<app-new-job>` in
     `invite-job-listing` mode so the recruiter can pick which of their
     other jobs to invite this applicant to. -->
<ng-template #jobsupplytemplate>
  <app-new-job [focus]="focus" [screenName]="'invite-job-listing'" [filterData]="candidateData"></app-new-job>
</ng-template>

